import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthorizationService } from "../../authorization.service";
import { KeyValue } from "../../key-value";

@Component({
  selector: "help-bank-content",
  templateUrl: "help-bank.component.html",
})
export class HelpBankComponent implements OnInit {
  helpItem = "other";
  role: string;

  constructor(
    private router: Router,
    public authService: AuthorizationService,
    private KeyValueService: KeyValue,
  ) {
    this.role = authService.getCRole();
  }

  ngOnInit(): void {
    console.log("dnfnfnf");
    this.KeyValueService.helpUrl$.subscribe((url1) => {
      console.log(" subscribe to helpUrl$ " + url1);
      this.helpItem = url1;
    });
  }
}
